// components/About.js
import React from 'react';
import { Box, Typography, Divider, CardMedia, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useAdmin } from '../context/AppContext';

const About = () => {
  const { adminProfile } = useAdmin();

  return (
    <Box
      sx={{
        padding: 3,
        maxWidth: 700,
        margin: '0 auto',
        textAlign: 'center',
        backgroundColor: (theme) => theme.palette.background.default,
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      {/* App Logo */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          alignItems: 'center',
          justifyContent: 'center',
          mb: 3,
          gap: { xs: 2, sm: 3 },
        }}
      >
        <CardMedia
          component="img"
          src={adminProfile?.appLogo}
          alt="App Logo"
          sx={{
            maxWidth: { xs: '80%', sm: '50%' },
            height: 'auto',
          }}
        />
      </Box>

      {/* Subtitle */}
      <Typography
        variant="h5"
        fontWeight="bold"
        color="primary"
        mb={1}
      >
        {adminProfile?.appTitle || 'Catering Service'}
      </Typography>

      <Typography variant="h6" color="textSecondary" mb={2}>
        Creating Unforgettable Culinary Experiences
      </Typography>

      <Divider sx={{ marginY: 2, backgroundColor: (theme) => theme.palette.primary.light }} />

      {/* Description */}
      <Typography
        variant="body1"
        color="textPrimary"
        paragraph
        sx={{ lineHeight: 1.8, textAlign: 'justify' }}
      >
        Based in the heart of Kerala, {adminProfile?.appTitle || 'Catering Service'} is here to bring your special moments to life through exceptional cuisine and personalized service. From intimate gatherings to grand celebrations, our team of culinary experts is dedicated to crafting a memorable dining experience that delights your guests and elevates your event.
      </Typography>

      <Typography
        variant="body1"
        color="textPrimary"
        paragraph
        sx={{ lineHeight: 1.8, textAlign: 'justify' }}
      >
        Whether it's a wedding, corporate event, or a family celebration, we take pride in serving exquisite, fresh, and locally sourced ingredients tailored to your needs. Let us handle every detail, so you can relax and enjoy the occasion.
      </Typography>

      <Divider sx={{ marginY: 2, backgroundColor: (theme) => theme.palette.primary.light }} />

      {/* Contact Information */}
      <Typography
        variant="h6"
        fontWeight="bold"
        sx={{ color: (theme) => theme.palette.primary.main }}
        mb={2}
      >
        Contact Us
      </Typography>

      {/* Contact Details */}
      <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={1}>
        <PhoneIcon color="primary" />
        <Typography variant="body1" color="textSecondary">
          <a
            href={`tel:${adminProfile?.whatsapp}`}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            {adminProfile?.whatsapp || '+91 9746929572'}
          </a>
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={1}>
        <EmailIcon color="primary" />
        <Typography variant="body1" color="textSecondary">
          <a
            href={`mailto:${adminProfile?.email}`}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            {adminProfile?.email }
          </a>
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" justifyContent="center" gap={1} mt={1}>
        <InstagramIcon color="primary" />
        <Typography variant="body1" color="textSecondary">
          <a
            href="https://www.instagram.com/shadhimubarakevents?igsh=cDVuemVmN2NzYXZ4"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            @shadhimubarakevents
          </a>
        </Typography>
      </Box>
    </Box>
  );
};

export default About;

